'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPING_INDICATOR_TIMEOUT_MS = exports.TYPING_INDICATOR_TIMEOUT_MS = 5500;


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/constants/typingStateConstants.js
// module id = 593
// module chunks = 2 3